import digitalData from 'digital-data';
import { getState, selectState } from '../../../analytics-state';
import {
  setAnalytics, getSSRError, getProductAnalytics, getCategoryBreadCrumbs,
  getPageType, getPageName, getLoadEvent, getDomainList
} from '../../../thd-analytics-utils';
import { nextDataSource } from '../../../generators/dataSources';
import { NUCLEUS, PAGE_AB_TEST } from '../../../constants';
import * as util from './util.pip.analytics';

export function* pip(response) {

  let { location, experienceName } = getState();
  if (!experienceName) {
    experienceName = window?.experienceMetadata?.name;
  }

  const { output: productRequest } = yield nextDataSource('product', {
    domains: getDomainList(experienceName)
  });

  const product = productRequest?.data?.product;
  if (!product) return;

  if (!product.fulfillment) {
    const { output: fulfillmentProduct } = yield nextDataSource('product', {
      domains: ['fulfillment'],
      hardDependencyDomain: true,
      timeout: 3000
    });
    const fulfillment = fulfillmentProduct.data?.product?.fulfillment;
    if (fulfillment) {
      product.fulfillment = fulfillment;
    }
  }

  const { info = {}, pricing = {} } = product || {};

  let pageTemplate = 'default';
  if (experienceName === 'major-appliances') {
    pageTemplate = 'appliance|default';
  }

  const hasApplianceExperienceQueryString = location?.search?.indexOf('exp=appliance') > -1;
  if (hasApplianceExperienceQueryString) {
    pageTemplate = 'appliance|v1';
  }
  digitalData.event = digitalData.event || [];
  digitalData.event.length = 0;

  if (digitalData?.content?.product) {
    digitalData.content.product = null;
  }

  if (info?.protectionPlanSku) {
    digitalData.event.push(util.getHdppDisplayedPreloadEvent());
  }

  let serviceAddons;
  if (info?.hasServiceAddOns) {
    serviceAddons = yield selectState('dataSources.serviceAddons', { timeout: 3000 });
  }

  const { output: productSubscribe } = yield nextDataSource('product', {
    domains: ['subscription'],
    timeout: 3000
  });
  const subscription = productSubscribe?.data?.product?.subscription;
  if (subscription) {
    product.subscription = subscription;
  }

  function getEventBadge(badges) {
    const itemBadges = badges
      .filter((badge) => { return badge?.name === 'Event Badge'; });
    return itemBadges?.[0];
  }

  digitalData.product = getProductAnalytics({ product, serviceAddons });

  if (product?.details?.collection) {
    const collectionDetail = yield selectState('dataSources.collectionDetail', { timeout: 3000 });

    if (collectionDetail) {
      digitalData.content = {
        ...digitalData.content,
        product: (collectionDetail.products || []).map((prod, index) => ({
          itemId: prod.identifiers?.itemId,
          index
        }))
      };
    }
  }

  if (product?.badges) {
    const eventBadge = getEventBadge(product.badges);
    if (eventBadge) {
      digitalData.content = {
        ...digitalData?.content,
        product: {
          ...digitalData?.content?.product,
          productInfo: {
            ...digitalData?.content?.product?.productInfo,
            badges: [...(digitalData?.content?.product?.productInfo?.badges || []),
              { type: 'event', name: eventBadge.label.toLowerCase() }]
          }
        }
      };
    }
  }

  const experienceTag = pricing?.promotion?.experienceTag;
  const featureName = (experienceTag === 'BOGO' && 'bogo') || (experienceTag === 'MSBONLINE' && 'multi-sku bulk') || '';
  if (featureName) {
    const contentModule = {
      name: 'buy box',
      feature: featureName,
      type: 'cta'
    };
    digitalData?.content?.module?.push(contentModule); // eslint-disable-line no-unused-expressions
  }

  let isSSRError = false;
  if (typeof window.__SSR_ERROR !== 'undefined' && window.__SSR_ERROR) {
    isSSRError = true;
  }

  let pageError = isSSRError ? getSSRError() : [];

  if (digitalData?.page?.error) {
    pageError = pageError.concat(digitalData?.page?.error);
  }

  if (!product?.taxonomy) {
    const { output: productTaxonomy } = yield nextDataSource('product', {
      domains: ['taxonomy'],
      timeout: 3000
    });
    const taxonomy = productTaxonomy?.data?.product?.taxonomy;
    if (taxonomy) {
      product.taxonomy = taxonomy;
    }
  }

  const { breadCrumbs = [] } = product?.taxonomy || {};

  digitalData.page = {
    pageInfo: {
      pageName: getPageName({ experienceName, postfix: product?.identifiers?.itemId }),
      pageLoadEvent: getLoadEvent(),
      abTest: experienceName === 'hd-home' ? PAGE_AB_TEST : '',
      pageType: getPageType({ experienceName }),
      pageTemplate,
      platform: NUCLEUS
    },
    category: getCategoryBreadCrumbs(breadCrumbs) || {},
    error: pageError
  };

  setAnalytics(digitalData);
}
